import routes from "./routes";
import { TiMessages } from "react-icons/ti";
import { BiMessageSquareAdd } from "react-icons/bi";
import { FaRegCalendarAlt } from "react-icons/fa";
import { GrTableAdd } from "react-icons/gr";
import { GrTransaction } from "react-icons/gr";
import { MdDashboard } from "react-icons/md";



export const menuItemsSeller = [
  {name: 'داشبورد', path :`${routes.DASHBOARD}`, type:'shallow' , icon:<MdDashboard /> },
  {name: 'لیست  تیکت ها ', path :`${routes.TICKETING}`, type:'shallow' , icon:<TiMessages /> },
  {name: '  تقویم', path :`${routes.CALENDEER}`, type:'shallow' , icon:<FaRegCalendarAlt /> },
  {name: 'بانک اطلاعاتی', path :`${routes.LEADSLIST}`, type:'shallow' , icon:<GrTableAdd/> },
  {name: 'مدل معامله', path :`${routes.DEALMODEL}`, type:'shallow' , icon:<GrTransaction />  },
]
export const menuItems = [
  {name: 'لیست  تیکت ها ', path :`${routes.TICKETING}`, type:'shallow' , icon:<TiMessages /> },
]
export function numberWithCommas(x:any) {
    x = x?.toString();
    var pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
    return x;
  }


  var persianNumber = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  var arabicNumber = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
  export function fixNumbers(str:any) {
    if (typeof str === "string") {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumber[i], i).replace(arabicNumber[i], i);
      }
    }
    return str;
  }
  export function calculatePrev (month:any){
    let prevYear = month.format("jYYYY");
    let prevMonth = Number(month.format("jM")) - 1;
    if(Number(prevMonth) <= 0){
      prevYear --;
      prevMonth = 12;
    }
    return `${prevYear}/${prevMonth}/15`
  }
  export function calculateNext (month:any) {
    let nextYear = month.format("jYYYY");
    let nextMonth = Number(month.format("jM")) + 1;
    if(Number(nextMonth) > 12){
      nextYear ++;
      nextMonth = 1;
    }
    return `${nextYear}/${nextMonth}/15`
  }